import { create } from 'zustand'

const getInitialTimeLimitMs = (): number => {
  const stored = sessionStorage.getItem('sessionInGameMinutes')
  const minutes = stored ? parseInt(stored, 10) : 0
  return Number.isFinite(minutes) && minutes > 0 ? minutes * 60 * 1000 : 0
}

const getInitialMaxLoss = (): number => {
  const stored = sessionStorage.getItem('sessionMaxLoss')
  const maxLoss = stored ? parseFloat(stored) : 0
  return Number.isFinite(maxLoss) && maxLoss > 0 ? maxLoss : 0
}

export type SessionLimitReason = 'time' | 'loss'

interface SessionLimitState {
  timeLimitMs: number
  maxLoss: number
  sessionStartAt: number
  isLimitReached: boolean
  reachedReason: SessionLimitReason | null
  isShowWarning: boolean
  hasWarned: boolean
  isShowForcedPopup: boolean
  markLimitReached: (reason: SessionLimitReason) => void
  showWarning: () => void
  dismissWarning: () => void
  showForcedPopup: () => void
}

export const useSessionLimitStore = create<SessionLimitState>(set => ({
  timeLimitMs: getInitialTimeLimitMs(),
  maxLoss: getInitialMaxLoss(),
  sessionStartAt: Date.now(),
  isLimitReached: false,
  reachedReason: null,
  isShowWarning: false,
  hasWarned: false,
  isShowForcedPopup: false,
  markLimitReached: reason => set(state => (state.isLimitReached ? state : { isLimitReached: true, reachedReason: reason })),
  showWarning: () => set({ isShowWarning: true, hasWarned: true }),
  dismissWarning: () => set({ isShowWarning: false }),
  showForcedPopup: () => set({ isShowForcedPopup: true }),
}))
